import { FC, memo, useMemo } from 'react';

import { Category, GameV1 } from '@/api/games';
import { groupMemberActiveBonus } from '@/helpers/user';
import { Badge } from '@/modules/game/components/Badge';
import { useCommonStore } from '@/store';

import { ScBadges } from './styled';

interface IBadgesProps extends Pick<GameV1, 'listCollections'> {
  isJackpot: boolean;
  isTournament: boolean;
}

export const Badges: FC<IBadgesProps> = memo(
  ({ isJackpot, isTournament, listCollections: categories }) => {
    const user = useCommonStore.use.user();

    const isWagering =
      categories.includes(Category.WAGERING) && groupMemberActiveBonus(user);
    const isExclusive = categories.includes(Category.EXCLUSIVE);
    const isInstant = categories.includes(Category.CASUAL);
    const isNew = categories.includes(Category.NEW);
    const isTop = categories.join(',').includes(Category.TOP);

    const isAnyBadges =
      isWagering ||
      isExclusive ||
      isTop ||
      isJackpot ||
      isNew ||
      isTournament ||
      isInstant;

    if (!isAnyBadges) return null;

    const badges = useMemo(() => {
      const arr = [];

      if (isExclusive) {
        arr.push(<Badge key="exclusive" type="exclusive" />);
      } else if (isWagering) {
        arr.push(<Badge key="wagering" type="wagering" />);
      } else {
        const possibleBadges = [
          isTop && <Badge key="top" type="top" />,
          isJackpot && <Badge key="jackpot" type="jackpot" />,
          isTournament && <Badge key="tournament" type="tournament" />,
          isNew && <Badge className="new" key="new" type="new" />,
          isInstant && <Badge key="instant" type="instant" />,
        ].filter((item): item is JSX.Element => !!item);

        arr.push(...possibleBadges.slice(0, 2));
      }

      return arr;
    }, [
      isWagering,
      isExclusive,
      isTop,
      isJackpot,
      isNew,
      isTournament,
      isInstant,
    ]);

    if (badges.length === 0) return null;

    return <ScBadges>{badges}</ScBadges>;
  }
);
